/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    loaderText: {
        textAlign: "center",
        paddingLeft: theme.spacing(1),
        color: theme.palette.grey[400]
    },
    loader: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& .preloader-circle-relative div": {
            height: `${theme.spacing(2.75)}px !important`,
            width: `${theme.spacing(2.75)}px !important`
        }
    },
    actionLoader: {
        paddingTop: theme.spacing(4)
    },
    dialogButton: {
        bottom: 50,
        textTransform: 'capitalize',
        fontFamily: 'GilmerMedium',
        fontSize: '13px',
        lineHeight: '16px',
        height: theme.spacing(5)
    },
    dialogRootStyle: {
        borderRadius: 15
    },
    dialogContent: {
        padding: theme.spacing(1)
    },
    primaryTitle: {
        fontFamily: 'GilmerMedium',
        textAlign: "center",
        fontSize: '23px',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2)
    },
    secondaryTitle: {
        textAlign: "center"
    },
    dialogActions: {
        display: "flex",
        justifyContent: "center",
        marginTop: theme.spacing(8.25)
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[200]
    }
}));
